<template>
  <fuit-or-yogurt
    @updatedElement="propagateChange"
    :initialValue="state"
    :student="studentName"
    :title="title"
    ref="element" />
</template>
<script>
import FuitOrYogurt from './FuitOrYogurt.vue'

export default {
  components: { FuitOrYogurt },
  created: function () {
    this.state = this.$attrs.student ? this.$attrs.student.snackType : this.byDefault
  },
  props: {
    title: {
      type: String,
      default: () => 'Merienda'
    },
    studentName: String
  },
  data: () => ({
    enabled: true,
    byDefault: 'fruta',
    state: ''
  }),
  methods: {
    setValue: function (value) {
      this.state = value
      this.$refs.element.setValue(value)
    },
    setEnable: function (value) {
      this.enabled = value
      this.$refs.element.setEnable(value)
    },
    propagateChange: function ({value}) {
      this.$emit('updatedElement',
        { snackType: value }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/diaryElements/SnackType.vue